<template>
  <div class="tag-wrapper">
    <mk-popover
      placement="right"
      trigger="hover"
      popper-class="tag-popper"
    >
      <template slot="reference">
        <div class="tag-item-wrapper cursor">
          <div
            v-for="(tagItem,index) in scope.row.showTags.slice(0, 2)"
            :key="index"
            class="tag-item"
          >
            {{ tagItem.name }}
          </div>
          <div
            v-if="scope.row.showTags.length > 2"
            class="more-tag"
          >
            <i class="el-icon-more" />
          </div>
        </div>
      </template>
      <div class="tag-item-wrapper">
        <div
          v-for="(tagItem,index) in scope.row.showTags"
          :key="index"
          class="tag-item"
        >
          {{ tagItem.name }}
        </div>
      </div>
    </mk-popover>
  </div>
</template>
<script>
export default {
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .tag-wrapper {
    .tag-item-wrapper {
      display: inline-flex;
      align-items: center;

      &:hover {
        .more-tag {
          background-color: #e6efff;
          border: 1px solid #d5e3ff;

          .el-icon-more {
            color: #4e78f0;
          }
        }
      }

      .tag-item {
        width: 64px;
        height: 22px;
        padding: 0 8px;
        margin-right: 8px;
        line-height: 22px;
        background-color: #ebeff4;
        border-radius: 2px;
        color: #6b7b88;
        font-size: 12px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:last-child {
          margin-right: 0;
        }
      }

      .more-tag {
        flex: none;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 22px;
        text-align: center;
        border-radius: 2px;
        border: 1px solid transparent;
        transition: all 0.3s;

        .el-icon-more {
          font-size: 12px;
          color: #767676;
        }
      }
    }
  }
</style>
<style lang="scss">
.tag-popper {
  min-width: unset;
  padding: 10px 0 0 10px;

  .tag-item-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 145px;
    max-height: 300px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: rgba(193, 193, 193, 0.8);
    }

    .tag-item {
      height: 22px;
      padding: 0 8px;
      margin-right: 10px;
      margin-bottom: 10px;
      line-height: 22px;
      background-color: #ebeff4;
      color: #6b7b88;
      border-radius: 2px;
      font-size: 12px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
